<template>
  <div class="container">
    <vue-element-loading :active="isActive" spinner="spinner" color="#FF6700" background-color="rgba(0, 0, 0, .2)"/>
    <!-- 填写保修单 -->
    <div class="box">
    <div class="write-info">
      <div class="write-info-row-1" @click="handleGoChooseBar">
        <span>网吧</span>
        <input v-reset-page  type="text" placeholder="请输入" :value="siteName"  disabled />
      </div>
      <div class="write-info-row-2">
        <span>网吧地址</span>
        <input v-reset-page  type="text" placeholder="请输入" v-model="siteAddress" />
      </div>
    </div>
    <!-- 网吧信息 -->
    <div class="write-info2">
      <div class="write-info-row-1">
        <span>
          <i style="color:red">*</i>联系人
        </span>
        <input v-reset-page  type="text" placeholder="请输入" v-model="name" />
      </div>
      <div class="write-info-row-2">
        <span>
          <i style="color:red">*</i>联系电话
        </span>
        <input v-reset-page 
          type="number"
          placeholder="请输入"
          v-model="phone"
          oninput="if(value.length>11)value=value.slice(0,11)"
          pattern="[0-9]*"
        />
      </div>
      <div class="write-info-row-3" @click="handleSelectTypeShow">
        <span>
          <i style="color:red">*</i>报修类型
        </span>
        <span class="selectType">{{typeName==''?'请输入':typeName}}</span>
      </div>
    </div>
    <!-- 保修描述 -->
    <div class="write-info3">
      <div class="title">报修描述</div>
      <div class="textarea">
        <textarea v-reset-page  name id cols="30" rows="10" placeholder="您可以在此描述报修内容" v-model="description" @blur="fixScroll"></textarea>
      </div>
      <div class="title">
        上传图片
        <span class="prompt">（最多9张）</span>
      </div>
      <div class="uploader-image">
        <van-uploader
          :after-read="afterRead"
          :before-delete="beforeDelete"
          v-model="fileList"
           multiple
          :max-count="9"
          :preview-size="60"
          @click-preview="clickPreview"
          @close-preview="closePreview"
        />
      </div>
    </div>
    <!-- 提交按钮 -->
    <div class="plbm-btn" @click="isLoadingClick && handleSubmitClick()">提交</div>
    </div>
    <!-- 报修类型选择 -->
    <van-popup v-model="statusShow" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        :columns="columns"
        confirm-button-text="完成"
        value-key="content"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
        <van-loading color="#008cff" v-show="isLoadingShow"/>
  </div>
</template>

<script>
import { Popup } from "vant";
import { Uploader } from "vant";
import { Picker } from "vant";
import { Toast, Dialog, Loading } from "vant";
import {
  PblmWarrantySave,
  PblmWarrantyInfo,
  PblmWarrantyType
} from "@/api/warranty";
import { UploadFile, HTUploadFile } from "@/api/public";
import axios from "axios";
import Exif from "exif-js";
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    vanUploader: Uploader,
    vanPicker: Picker,
    vanPopup: Popup,
    VueElementLoading,
    vanLoading:Loading
    
  },
  data() {
    return {
      fileList: [],
      uploadImagePathList: [],
      columns: [],
      //   isSelectTypeShow:false,
      statusShow: false,
      loadingShow:true,
      siteName: "",
      siteAddress: "",
      name: "",
      phone: "",
      typeName: "",
      maintenanceTypeId: "",
      description: "",
      arr: "",
      updataSiteAddress: "",
      formData:'',
      isActive:false,
      isLoadingShow:false,
      isLoadingClick:true
    };
  },

  mounted() {

    this.requestPblmWarrantyInfo();
    this.requestPblmWarrantyType();
    if (window.history && window.history.pushState) {
      window.addEventListener("popstate", this.closePreview, false); //false阻止默认事件
    }
  },
    destroyed(){
     window.removeEventListener('popstate', this.closePreview, false);//false阻止默认事件
   },
  methods: {
  fixScroll() {
    window.scrolll(0,0);
   },
    clickPreview() {
        history.pushState(null, null, document.URL);
    },
    closePreview() {
        console.log('关闭了')
    },
    afterRead(file) {
      console.log("length = " + file.length);
      console.log("fileList" + file);
      console.log("店家");
      let fileArray = [];
      if (file.length > 1) {
        fileArray = file;
      } else {
        fileArray.push(file);
      }
      this.isActive = true;
      let that = this;
      fileArray.forEach(imageFile => {
        console.log("店家:" + imageFile);
        let formData = new window.FormData();
        this.$utils.compress(imageFile.file, 0.5, function(err, data) {
          if (err) {
            console.log(err);
            return;
          }
          formData.append("file", data);

          let config = {
              headers: {'Content-Type': 'multipart/form-data'}
          }
          // console.log(formData)
          // HTUploadFile({formData}).then(res =>{
          //     console.log(res)
          // });
          // 添加请求头
          // let baseUrl = this.$utils.getBaseUrl();
      
           axios.post('https://kf.qingruilin.com.cn/netbar/api/common/v1/pic_upload', formData, config)
           .then(response => {
             let res = response.data;
             console.log(res.data)
             if(res.code == 200){
               console.log("地址:"+res.data.relativePicPath);
              //  that.arr += res.data.relativePicPath + ','
              that.uploadImagePathList.push(res.data.relativePicPath);
              that.isActive = false;
             }
           })
        });
      });
    },
    beforeDelete(index) {
      this.uploadImagePathList.splice(index, 1);
      return true;
    },
    // 跳转选择网吧
    handleGoChooseBar() {
      console.log('11')
        this.$router.push({
           path:'/choosebar',
           query:{
              url:'/writewarranty'
           }
        })
    },
    //   获取地址网吧名称
    requestPblmWarrantyInfo() {
      // let internet_bar_id = sessionStorage.getItem('internetBarId')
      let internet_bar_id = this.$cookies.get('internetBarId')
      PblmWarrantyInfo({internetBarId:internet_bar_id}).then(res => {
        console.log(res);
        this.siteName = res.data.siteName;
        this.siteAddress = res.data.siteAddress;
        this.updataSiteAddress = this.siteAddress;
      });
    },
    // 上传文件
    requestHTUploadFile() {
          HTUploadFile(formData).then(res => {
            console.log(res);
            if (res.code == 200) {
              console.log("地址:" + res.data.relativePicPath);
              //  that.arr += res.data.relativePicPath + ','
              that.uploadImagePathList.push(res.data.relativePicPath);
            }
          });
    },
    // 报修类型列表
    requestPblmWarrantyType() {
      PblmWarrantyType().then(res => {
        let columnsArr = res.data;
        let newcolumnsArr = [];
        columnsArr.forEach((item, index) => {
          newcolumnsArr.push(item);
        });
        console.log(newcolumnsArr);
        this.columns = newcolumnsArr;
      });
    },
    // 点击保存
    requestPblmWarrantySave() {
      let name = this.name;
      let phone = this.phone;
      let maintenanceTypeId = this.maintenanceTypeId;
      let description = this.description;
      let arr = this.uploadImagePathList.join(",");
      let siteAddress = this.siteAddress
      let internet_bar_id = this.$cookies.get('internetBarId')
      console.log("上传图片地址:" + arr);
      if (!name) {
        Toast("请输入联系人");
        return false;
      }
      if (!phone) {
        Toast("请输入手机号");
        return false;
      }
      if (!description) {
        Toast("请输入报修描述");
        return false;
      }
      // if (!arr) {
      //   Toast("请上传照片");
      //   return false;
      // }
      this.isLoadingShow = true
      if(this.isLoadingShow) {
          this.isLoadingClick = false
        }else {
          this.isLoadingClick = true 
        }
      PblmWarrantySave({
        internetBarId:internet_bar_id,
        name: name,
        phone: phone,
        maintenanceTypeId: maintenanceTypeId,
        description: description,
        siteAddress:siteAddress,
        pictureUrl: arr
      }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.isLoadingShow = false
          this.$router.push({
            path:'/pblmwarranty'
          });
        }
      });
    },
    //  报修类型的chaage事件
    onConfirm(value, index) {
      console.log(value);
      this.typeName = value.content;
      this.maintenanceTypeId = value.id;
      this.statusShow = false;
    },
    // 点击取消的时候隐藏
    onCancel() {
      this.statusShow = false;
    },
    // 是否展示选择报修类型
    handleSelectTypeShow: function() {
      this.statusShow = !this.statusShow;
    },
    // 上传文件
    async requestUploadFile(base64Img) {
      UploadFile({ base64Img: base64Img }).then(res => {
        console.log(res);
        this.arr += res.data + ",";
      });
    },

    // 提交
    handleSubmitClick() {
      // 点击判断地址是否一致
      if (this.siteAddress != this.updataSiteAddress) {
        Dialog.confirm({
          title: "提示",
          message: "是否修改网吧基本信息中的地址"
        })
          .then(() => {
            this.requestPblmWarrantySave();
          })
          .catch(() => {
            this.requestPblmWarrantyInfo();
          });
      } else {
        this.requestPblmWarrantySave();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  position:static;
    .box {
      height:calc(100vh + 1px);
      // 第一个模块
      .write-info {
        width: 375px;
        height: 106px;
        padding: 0 13px;
        box-sizing: border-box;
        background-color: #ffffff;
        text-align: left;
        color: #333333;
        font-size: 15px;
        margin-top: 10px;
        border-bottom: 1px solid #f2f2f2;
        .write-info-row-1 {
          width: 100%;
          height: 50px;
          padding-top: 15px;
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          input {
            display: inline-block;
            border: none;
            width: 210px;
            margin-left: 60px;
            &::-webkit-input-placeholder {
              color: #cccccc;
              font-size: 16px;
              box-sizing: border-box;
              padding-top: 3px;
            }
            &:disabled {
              background-color: #ffffff;
            }
          }
        }
        .write-info-row-2 {
          width: 100%;
          padding-top: 15px;
          box-sizing: border-box;
          input {
            border: none;
            width: 230px;
            margin-left: 30px;
            &::-webkit-input-placeholder {
              color: #cccccc;
              font-size: 16px;
              box-sizing: border-box;
              padding-top: 3px;
            }
            &:disabled {
              background-color: #ffffff;
            }
          }
        }
      }
      // 第二个模块
      .write-info2 {
        width: 375px;
        height: 158px;
        padding: 0 13px;
        box-sizing: border-box;
        background-color: #ffffff;
        text-align: left;
        color: #333333;
        font-size: 15px;
        margin-top: 10px;
        .write-info-row-1 {
          width: 100%;
          height: 50px;
          padding-top: 15px;
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          input {
            border: none;
            margin-left: 33px;
            &::-webkit-input-placeholder {
              color: #cccccc;
              font-size: 16px;
              box-sizing: border-box;
              padding-top: 3px;
            }
          }
        }
        .write-info-row-2 {
          width: 100%;
          height: 50px;
          padding-top: 15px;
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;
          input {
            border: none;
            margin-left: 20px;
            &::-webkit-input-placeholder {
              color: #cccccc;
              font-size: 16px;
              box-sizing: border-box;
              padding-top: 3px;
            }
          }
        }
        .write-info-row-3 {
          width: 100%;
          height: 50px;
          line-height: 50px;
          box-sizing: border-box;
          .selectType {
            display: inline-block;
            width: 192px;
            margin-left: 20px;
            color: #cccccc;
            font-size: 16px;
          }
        }
      }
      // 第三个模块信息描述
      .write-info3 {
        width: 375px;
        // height: 100%;
        overflow-y: hidden;
        padding: 0 13px;
        box-sizing: border-box;
        background-color: #ffffff;
        text-align: left;
        color: #333333;
        font-size: 15px;
        margin-top: 10px;
        .title {
          text-align: left;
          padding: 18px 0;
          box-sizing: border-box;
          .prompt {
            color: #999999;
            font-size: 13px;
          }
        }
        .textarea {
          width: 100%;
          height: 100%;
          textarea {
            background-color: #eaeaea;
            width: 349px;
            height: 100px;
            border: none;
            border-radius: 8px;
            padding: 15px 10px;
            box-sizing: border-box;
            &::-webkit-input-placeholder {
              color: #999999;
            }
          }
        }
        //上传图片
        .van-uploader {
          margin-bottom: 20px;
        }
      }
      // 按钮
      .plbm-btn {
        width: 350px;
        height: 44px;
        background: -webkit-linear-gradient(left, #05aefc, #008cff);
        margin: 0 auto;
        border-radius: 22px;
        font-size: 16px;
        color: $white-color;
        line-height: 44px;
        margin: 20px auto;
      }
  }
}
</style>
<style lang="scss">
.van-uploader__preview {
  margin-left: 6px;
}
.van-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -32px;
}
</style>